import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from 'src/app/_service/shared.service';
import { HelpService } from 'src/app/_service/help.service';
import { ActivatedRoute, Router } from '@angular/router';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CkeditorAdapter } from 'src/app/ckeditor-adapter';

@Component({
  selector: 'app-add-edit-help',
  templateUrl: './add-edit-help.component.html',
  styleUrls: ['./add-edit-help.component.css']
})
export class AddEditHelpComponent implements OnInit {
  public Editor = ClassicEditor;
  helpForm: FormGroup; submitted = false; helpId: any = ''; loading: boolean = false; loader;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private helpapi: HelpService, public sharedapi: SharedService, private formBuilder: FormBuilder) {

    this.helpForm = this.formBuilder.group({
      'description': [null, Validators.required]
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['help_id']) {
        this.helpId = params['help_id'];
        this.patchPinCodeData(this.helpId);
      }
    });

    this.Editor.defaultConfig = {
      toolbar: {
        items: [
          'heading',
          '|',
          'bold',
          'italic',
          '|',
          'bulletedList',
          'numberedList',
          '|',
          'insertTable',
          '|',
          'undo',
          'redo'
        ]
      },
      image: {
        toolbar: [
          'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
          '|',
          'imageStyle:full',
          'imageStyle:side',
          '|',
          'imageTextAlternative'
        ]
      },
      table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
      },
      language: 'en'
    };

  }

  ngOnInit(): void {
  }

  get f() { return this.helpForm.controls; }

  async createhelp() {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.helpForm.invalid) {
      this.loading = false;
      return;
    }
    this.helpId = this.activatedRoute.snapshot.paramMap.get('help_id');
    this.helpForm.value.id = parseInt(this.helpId);
    await this.helpapi.saveHelp(this.helpForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.router.navigateByUrl('/help-list');
        this.helpForm.reset();
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async patchPinCodeData(helpId) {
    await this.helpapi.getHelpEditData(this.helpId).subscribe((response: any) => {
      if (response.status) {
        this.helpForm.patchValue({
          'description': response.data.description
        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  onReady(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return new CkeditorAdapter(loader, editor.config);

    };
  }



}
